import React from 'react';
import {Badge, Button} from 'reactstrap';
import TTLProxy from "../../common/TTLAsyncProxy";
import Utils from "../../common/Utils";
import TabsRenderer from "../../common/TabsRenderer/TabsRenderer";
import Icon from 'react-icons-kit';
import {ic_notifications} from 'react-icons-kit/md/ic_notifications';
import MDSpinner from 'react-md-spinner';
import SmartDialog from '../SmartDialog/SmartDialog';
import PropTypes from 'prop-types';
import {NotificationEndpoints, USSDEndpoints} from "../../common/ProxyEndpoints";
import HTML from '../../common/HtmlHelpers';

import RequestView from './Templates/TractorRequest';
import AlertView from './Templates/Alert';
import OthersView from './Templates/Other';
import GeoView from './Templates/Geo';
import moment from 'moment';
import Confirm from "../Confirm/Confirm";
import MDProgress from 'react-md-progress-bar';
import {broadcastEvent} from "../../common/Events/EventSource";
import EventActions from "../../common/Events/Actions";

const MIN_PAGE_HEIGHT = 380;

const Styles = {
    tabPages:{
        minHeight: MIN_PAGE_HEIGHT
    }
};


class NotificationsView extends React.Component {

    static propTypes = {
        category: PropTypes.string,
        noNotificationsMessage: PropTypes.string,
        busyMessage: PropTypes.string,
        renderItem: PropTypes.func,
        onUpdate: PropTypes.func
    };

    static defaultProps = {
        noNotificationsMessage: "No notifications available",
        busyMessage: "Please hold on. Getting notifications..."
    };

    proxy = TTLProxy.getInstance();


    constructor(props){
        super(props);
        this.state = {
            notifications: [],
            errorMessage: null,
            initialStateLoaded: false,
            isBusy: false,
            contextNotification: null,
            //  Holds individual item heights
            itemHeights: {}
        };

        this._notificationsViews = {};

    }

    getCategory(){
        return this.props.category;
    }

    ensureLoaded(){

        if(this.state.initialStateLoaded)
           return Promise.resolve();

        this._notificationsViews = {};

        return this.loadState().then(() => {

            //  set state loaded
            this.setState({
                initialStateLoaded : true
            });

        });
    }

    invokeUpdate(action,args){

        const props = this.props;
        if(props.onUpdate){
            return props.onUpdate(action,args);
        }

    }

    removeAllNotifications(){
        const props = this.props;
        this.invokeUpdate('clear',props.category);
    }

    loadState(){

        const params = NotificationEndpoints.getUserNotifications(this.props.category);

        this.setState({
           isBusy: true,
           errorMessage: null
        });

        return this.proxy.processRequest(params).then(response => {

            if(response.ok){

                const payload = response.getPayload().sort((a,b) => {
                    return -moment(a.date_created).diff(b.date_created);
                });
                for(let i = 0 ; i < payload.length ; i++){
                    payload[i].metadata = JSON.parse(payload[i].metadata);
                }

                this.setState({
                    notifications: payload
                });
            }

            this.setState({
                isBusy : false
            });

        }).catch(err =>{

            this.setState({
               errorMessage: Utils.getResponseError(err),
                isBusy :false
            });

        });

    }

    renderBusy(){
        return <div className="text-center animated fade fadeIn" style={{padding: 80}}>
            <MDSpinner size={45}/>
            <p style={{ marginTop: 10 }}>{this.props.busyMessage}</p>
        </div>
    }


    render(){

        const state = this.state;
        const props = this.props;
        const isBusy = state.isBusy;
        const proxy = this.proxy;

        if(isBusy || !this.state.initialStateLoaded){
            return this.renderBusy();
        }

        const notifications = state.notifications || [];
        if(notifications.length == 0){

            return <div className="text-center">
                <p>{props.noNotificationsMessage}</p>
            </div>

        }else{

            return <div>



                {notifications.map((notif,key) => {

                    return <div key={key} ref={r => this._notificationsViews[notif.id] = r}>
                        {props.renderItem({
                            notif: notif,
                            refresh: this.loadState.bind(this),
                            onDelete: () => this.invokeUpdate('remove', notif)

                        })}
                    </div>

                })}
            </div>
        }
    }
}

const ToggleView = (props) => {

    return (<div style={props.style}>
        <label className="switch switch-3d switch-primary switch-xs" style={{marginRight: 5 }}>
        <input type="checkbox" className="switch-input" disabled={props.disabled}  checked={props.checked} style={{marginTop: 3}} onChange={(evt) => {

            const value = evt.target.checked;
            if(props.onChange)
                props.onChange(value);

        }}/>
        <span className="switch-label"></span>
        <span className="switch-handle"></span>
        </label>
         {props.text}
    </div>);

};

class UserNotifications extends React.Component{

    //
    proxy = TTLProxy.getInstance();

    //  The pages for the various tabs
    pages = [];

    _isMounted;

    constructor(props){
        super(props);

        this.state = this.getInitialState();
        this.onUpdate = this.onUpdate.bind(this);

        this.pages = [
            {
                title: () => <div><i className="icon-docs"></i> Tractor Requests {this.state.summary.tractor_requests.unseen > 0 ? <Badge color="primary" pill={true}>{this.state.summary.tractor_requests.unseen}</Badge> : null}</div>,
                style: Styles.tabPages,
                render: () => {

                    return <NotificationsView category="tractor_request"
                                              noNotificationsMessage="No tractor requests notifications available!"
                                              onUpdate={this.onUpdate}
                                              ref={r => this._tractorRequests = r}
                                              renderItem={( { notif  , onDelete } ) => <RequestView services={this.state.services}
                                                                                                    onDelete={onDelete}
                                                                                                    notification={notif} />
                                              }/>;

                }

            },
            {
                title: () => <div><i className="fa fa-info"></i> Alerts {this.state.summary.alert.unseen > 0 ? <Badge color="primary" pill={true}>{this.state.summary.alert.unseen}</Badge> : null}</div>,
                style: Styles.tabPages,
                render: () => {
                    return <NotificationsView category="alert"
                                              noNotificationsMessage="No alert notifications available!"
                                              onUpdate={this.onUpdate}
                                              ref={r => this._alerts = r}
                                              renderItem={( { notif }) => <AlertView notification={notif}/>
                                              }/>
                }
            },
            {
                title: () => <div><i className="fa fa-location-arrow"></i> Geo {this.state.summary.geo.unseen > 0 ? <Badge color="primary" pill={true}>{this.state.summary.geo.unseen}</Badge> : null}</div>,
                style: Styles.tabPages,
                render: () => {
                    return <NotificationsView category="geo"
                                              noNotificationsMessage="No geo messages or notifications available!"
                                              ref={r => this._geo = r}
                                              renderItem={( { notif } ) => <GeoView notification={notif} />
                                              }/>
                }
            },
            {
                title: () => <div><i className="fa fa-tags"></i> Other {this.state.summary.other.unseen > 0 ? <Badge color="primary" pill={true}>{this.state.summary.other.unseen}</Badge> : null}</div>,
                style: Styles.tabPages,
                render: () => {

                    return <NotificationsView category="other"
                                              noNotificationsMessage="No messages available!"
                                              onUpdate={this.onUpdate}
                                              ref={r => this._other = r}
                                              renderItem={( { notif , refresh }) => {

                                                  return <OthersView notification={notif}
                                                                     onRefresh={refresh}/>;
                                              }}/>
                }
            }

        ];

    }

    executeRequest(action , complete , onError ){

        this.setStateSafe({
            isBusy: true
        });

        return action.then(response => {

            let _out;

            if(complete !== undefined){
                _out = complete(response);
            }

            if(_out && typeof _out.then === "function"){

                return _out.then(() => {

                    this.setStateSafe({
                        isBusy: false
                    });
                });

            }
            else {

                this.setStateSafe({
                    isBusy: false
                });
            }

        }).catch(err => {

            this.setStateSafe({
                isBusy: false
            });

            if(onError !== undefined){
                return onError(err);
            }

        });
    }

    onUpdate(action,args){

        const proxy = this.proxy;

        switch (action){

            case 'begin_busy':

                this.setState({
                    isBusy: true
                });

                break;
            case 'end_busy':

                this.setState({
                    isBusy: false
                });

                break;
            case 'clear':

                return this.executeRequest(

                    proxy.processRequest(NotificationEndpoints.clear(args)),

                    response => {

                        return Promise.all([

                            this.loadState(),

                            //  Reload page state
                            this.getTabPage( this._tabs.getActiveTab() ).loadState()

                        ]).then(t => true);

                    },

                    err => {
                        HTML.toastWarning(Utils.getResponseError(err));
                    }
                );

                break;
            case 'remove':

                this.setStateSafe({
                    contextNotification: args
                }, () => {
                    this._confirmDeleteNotifDlg.show();
                });

                break;
            case 'update_summary':
                return this.fetchSummary();
        }
    }

    show(){

        //  set initial state
        this.setState(this.getInitialState());

        //  Ensure to load state
        this.loadState();

        //
        this._dlg.show();
    }

    toggle(){
        this._dlg.toggle();
    }

    getInitialState(){

        return {
            isLoaded: false,
            isBusy: false,
            notificationsEnabled: Utils.getUserEntity( this.proxy.getUserInfo() ).request_notification , //query from settings store
            summary: {

                tractor_requests: {
                    total: 0,
                    seen: 0,
                    unseen: 0
                },

                alert: {
                    total: 0,
                    seen: 0,
                    unseen:0
                },

                geo:{
                    total: 0,
                    seen: 0,
                    unseen: 0
                },

                other: {
                    total: 0,
                    seen:0 ,
                    unseen: 0
                }
            },
            services: [],
            visibleNotifications: []
        };

    }

    fetchSummary(){

        return this.proxy.processRequest( NotificationEndpoints.getSummary() ).then(response => {

            //
            this.setState({
                summary: response.getPayload()
            });

        });
    }

    fetchServices(){

        return this.proxy.processRequest( USSDEndpoints.getUSSDServices() ).then(response => {

            this.setState({
                services: response.getPayload()
            });

        });
    }

    loadState(){

        const proxy = this.proxy;

        this.setState({
            isBusy: true
        });

        return Promise.all([

            //  Fetch summary
            this.fetchSummary(),


            //  Fetch ussd services
            this.fetchServices()

        ]).then(() => {

            //
            this.onActivateTab(0);

            //
            this.setState({
                isBusy: false
            });

        }).catch(err =>{

            HTML.toastWarning(Utils.getResponseError(err));

            this.setState({
                isBusy: false
            });

        });
    }

    getTabPage(tabIndex){

        switch (tabIndex){
            case 0:
                return this._tractorRequests;
            case 1:
                return this._alerts;
            case 2:
                return this._geo;
            case 3:
                return this._other;
        }

    }

    onActivateTab(tabIndex){

        const page = this.getTabPage(tabIndex);
        if(page){

            //
            page.ensureLoaded();

            //
            const category = page.getCategory();
            const visible = this.state.visibleNotifications;
            if(visible.indexOf(category) < 0){

                visible.push(category);

                this.setState({
                    visibleNotifications: visible
                });

            }


        }
    }

    onCloseDialog(){

        //  clear all seen notifications
        const visible = this.state.visibleNotifications.join(",");
        return this.proxy.processRequest( NotificationEndpoints.checkAllUnseen(visible) ).then(() => {
            broadcastEvent(EventActions.NotificationUpdate);
        });

    }

    setStateSafe(state,callback){

        if(this._isMounted){
            this.setState(state,callback);
        }

    }

    componentWillMount(){
        this._isMounted = true;
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    render() {

        const user = TTLProxy.getInstance().getUserInfo();

        return <SmartDialog showCancelButton={true} ref={r => this._dlg = r} onExit={this.onCloseDialog.bind(this)} title={<span> <Icon icon={ic_notifications} size={24}/> Notifications </span>}>

                <Confirm ref={r => this._clearAllDlg = r}
                         title="Remove All Notifications"
                         body={"Are you sure you really want to clear all notifications?"}
                         confirmText="Clear"
                         confirmBtnColor="danger"
                         onConfirm={() => {

                             const page = this.getTabPage( this._tabs.getActiveTab() );
                             return page.removeAllNotifications();

                         }}/>

                <Confirm
                    confirmText="Delete Notification"
                    cancelText="Cancel"
                    onConfirm={() => {

                        const notif = this.state.contextNotification;
                        const proxy = this.proxy;

                        return this.executeRequest(

                            proxy.processRequest( NotificationEndpoints.delete(notif.id) ),

                            res => {

                                return Promise.all([

                                    this.loadState(),

                                    //  Reload page state
                                    this.getTabPage( this._tabs.getActiveTab() ).loadState()

                                ]).then(t => true);
                            },
                            err => {
                                HTML.toastWarning(Utils.getResponseError(err));
                                return false;
                            }

                        ).then(() => {

                            //  toggle dialog
                            this._confirmDeleteNotifDlg.toggle();
                        });


                    }}
                    body={<span>Are you sure you want delete selected notification <b style={{display: "inline"}}>permanently</b>?</span>}
                    confirmBtnColor="danger"
                    title="Remove Notification"
                    ref={(input) => {
                        this._confirmDeleteNotifDlg = input;
                    }}/>

                    <TabsRenderer tabContentStyle={{ minHeight: 380 , maxHeight: 382 , overflowY: "auto" }}
                                  onActivate={this.onActivateTab.bind(this)} ref={ref => this._tabs = ref }
                                  pages={this.pages}
                                  defaultPage={0}
                                  activeTabClassname="notif-active-tab" />

                    <div style={{ width : '100%', marginTop: 4 }} className="clearfix">

                        <div className="pull-left">

                            <ToggleView text={'Enable Notifications'} style={{marginTop: '8px'}} checked={this.state.notificationsEnabled} onChange={(value) =>{

                                const cVal = this.state.notificationsEnabled;

                                this.setState({
                                    notificationsEnabled: value,
                                    isBusy: true
                                });

                                //
                                this.proxy.updateUserEntity({
                                    request_notification: value
                                }).then(() =>{

                                    this.setState({
                                        isBusy: false
                                    });

                                }).catch(err => {

                                    this.setState({
                                        notificationsEnabled: cVal,
                                        isBusy: false
                                    });

                                });

                            }} />
                        </div>

                        <div className="pull-right">
                            <Button color={"secondary"} style={{ borderRadius: 4 }} onClick={() => this._clearAllDlg.show() }><i className="fa fa-trash"></i> Clear</Button>
                        </div>

                    </div>

                    {this.state.isBusy && <MDProgress overlay={true}/>}

                </SmartDialog>

    }
}

export default UserNotifications;


// WEBPACK FOOTER //
// ./src/components/UserNotifications/UserNotifications.js